var exports = {
  "KE": "AdvancedSettingsTab.module__toolbar___aDNGb0",
  "uW": "AdvancedSettingsTab.module__section___aDNGb0",
  "bV": "AdvancedSettingsTab.module__sectionHeader___aDNGb0",
  "sq": "AdvancedSettingsTab.module__sectionTitleRow___aDNGb0",
  "Gf": "AdvancedSettingsTab.module__sectionTitle___aDNGb0",
  "yV": "AdvancedSettingsTab.module__sectionDescription___aDNGb0",
  "_R": "AdvancedSettingsTab.module__itemList___aDNGb0",
  "rd": "AdvancedSettingsTab.module__settingRow___aDNGb0",
  "gP": "AdvancedSettingsTab.module__settingRowFullWidth___aDNGb0",
  "cY": "AdvancedSettingsTab.module__settingMain___aDNGb0",
  "Gn": "AdvancedSettingsTab.module__settingMainInteractive___aDNGb0",
  "jF": "AdvancedSettingsTab.module__settingTitleRow___aDNGb0",
  "h3": "AdvancedSettingsTab.module__settingTitle___aDNGb0",
  "jg": "AdvancedSettingsTab.module__settingDescription___aDNGb0",
  "D9": "AdvancedSettingsTab.module__settingAction___aDNGb0",
  "kN": "AdvancedSettingsTab.module__settingActionFullWidth___aDNGb0",
  "lv": "AdvancedSettingsTab.module__controlStackCompact___aDNGb0",
  "p$": "AdvancedSettingsTab.module__emptyState___aDNGb0",
};

module.exports = exports;
